var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSyncFailed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7216 17.4984H2.2774C1.97969 17.4984 1.70459 17.3395 1.55573 17.0817C1.40688 16.8239 1.40688 16.5062 1.55574 16.2484L9.2774 2.91505C9.42638 2.65765 9.70124 2.49915 9.99865 2.49915C10.2961 2.49915 10.5709 2.65765 10.7199 2.91505L18.4416 16.2484C18.5904 16.5061 18.5904 16.8236 18.4418 17.0814C18.2931 17.3391 18.0183 17.4981 17.7207 17.4984H17.7216ZM9.16657 13.3317V14.9984H9.94407H9.99824H10.0524H10.8316V13.3317H9.16657ZM9.16657 7.49839V11.6651H10.8332V7.49839H9.16657Z",
    fill: "#F2B14F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyncFailed);
export default __webpack_public_path__ + "static/media/sync_failed.ec09ac727095add38150e4cdfe313458.svg";
export { ForwardRef as ReactComponent };